import { h } from "preact";
import { withStyles } from "@mui/styles";
import Button from "@mui/material/Button";
import palette from "./palette";

// The `withStyles()` higher-order component is injecting a `classes`
// prop that is used by the `Button` component.
const NavSecondaryButton = withStyles({
  root: {
    backgroundColor: palette.secondary.main,
    borderRadius: 15,
    border: 0,
    color: "white",
    fontWeight: "bold",

    padding: "0px 10px",
    marginRight: "20px",
  },
  label: {
    textTransform: "capitalize",
  },
})(Button);

export default NavSecondaryButton;
